"use strict";

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _validate = require("@widergy/web-utils/lib/validate");

var _files = require("@widergy/web-utils/lib/constants/files");

var _image = require("@widergy/web-utils/lib/image");

var _formTypes = require("../../types/formTypes");

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _constants = require("./constants");

var _layout = _interopRequireDefault(require("./layout"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var isImage = function isImage(file) {
  return _files.inputFiles.image.validType.includes(file.type);
};

var isPDF = function isPDF(file) {
  return _files.inputFiles.pdf.validType.includes(file.type);
};

var isValidFile = function isValidFile(file) {
  return isImage(file) || isPDF(file);
};

var AttachmentContainer = /*#__PURE__*/function (_Component) {
  _inherits(AttachmentContainer, _Component);

  function AttachmentContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AttachmentContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AttachmentContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false,
      name: '',
      preview: '',
      error: false,
      errorText: _constants.FORMAT_ERROR_TEXT
    });

    _defineProperty(_assertThisInitialized(_this), "loadElement", function () {
      var input = _this.props.input;
      (0, _utils.getBlobFromUrl)(input.value, function (response) {
        if (response && response.type) {
          var fileType = response.type.substring(response.type.indexOf('/') + 1);

          _this.setState({
            name: _this.getDefaultAttachment(input.value, fileType)
          });

          if (isImage(response)) _this.buildPreview(response);
        } else _this.setState({
          name: _this.getDefaultAttachment(input.value)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.hasDefaultValueToLoad()) _this.loadElement();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var input = _this.props.input;
      var _this$state = _this.state,
          preview = _this$state.preview,
          name = _this$state.name;

      if (!preview && !name && prevProps.input.value !== _this.props.input.value) {
        if (_this.hasDefaultValueToLoad()) _this.loadElement();else if (_typeof(input.value) === 'object' && isValidFile(input.value.file)) _this.setFile(input.value.file);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getDefaultAttachment", function (url, fileType) {
      return url && typeof url === 'string' && _react["default"].createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, _constants.DEFAULT_ATTACHMENT_NAME, fileType && ".".concat(fileType));
    });

    _defineProperty(_assertThisInitialized(_this), "hasDefaultValueToLoad", function () {
      return _this.props.input.value && typeof _this.props.input.value === 'string';
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ev) {
        var file, resizeConfig, fileErrorTexts, validation;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = ev.target.files[0];
                resizeConfig = _this.props.resizeConfig;
                fileErrorTexts = {
                  formatError: _constants.FORMAT_ERROR_TEXT,
                  sizeError: "".concat(_constants.SIZE_ERROR_TEXT, " ").concat(Math.round(_this.props.maxFileSize / 1000000), "Mb.")
                };

                _this.setState({
                  error: false
                });

                if (!file) {
                  _context.next = 16;
                  break;
                }

                _context.next = 7;
                return (0, _validate.fileSignatureValidation)(file, _this.props.fieldTypes, file.type);

              case 7:
                validation = _context.sent;

                if (!validation) {
                  _context.next = 15;
                  break;
                }

                if (!isImage(file)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 12;
                return (0, _image.resizeImage)(file, resizeConfig);

              case 12:
                file = _context.sent;

              case 13:
                validation = (0, _validate.fileSizeValidation)(file, _this.props.maxFileSize);
                return _context.abrupt("return", validation ? _this.setFile(file) : _this.onFailValidation(fileErrorTexts.sizeError));

              case 15:
                _this.onFailValidation(fileErrorTexts.formatError);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onFailValidation", function (errorMessage) {
      _this.setState({
        error: true,
        errorText: errorMessage
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFile", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setState({
                  loading: true,
                  name: file.name
                });

                if (isImage(file)) _this.buildPreview(file);

                _this.props.onChange({
                  file: file
                });

                _this.setState({
                  loading: false
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "buildPreview", function (file) {
      var reader = new FileReader();

      reader.onload = function (e) {
        return _this.setState({
          preview: e.target.result
        });
      };

      reader.readAsDataURL(file);
    });

    _defineProperty(_assertThisInitialized(_this), "removeValue", function () {
      _this.setState({
        loading: false,
        name: '',
        preview: ''
      });

      _this.props.onChange('');
    });

    return _this;
  }

  _createClass(AttachmentContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          loadingTextClassname = _this$props.loadingTextClassname,
          errorClassname = _this$props.errorClassname,
          previewClassname = _this$props.previewClassname,
          containerClassname = _this$props.containerClassname,
          fieldTypes = _this$props.fieldTypes,
          classes = _this$props.classes,
          icon = _this$props.icon,
          input = _this$props.input,
          disabled = _this$props.disabled;
      var _this$state2 = this.state,
          name = _this$state2.name,
          preview = _this$state2.preview,
          loading = _this$state2.loading,
          error = _this$state2.error,
          errorText = _this$state2.errorText;
      var loadingDefaultValue = this.hasDefaultValueToLoad() && !name;
      return _react["default"].createElement(_layout["default"], {
        loading: loading || loadingDefaultValue,
        uploadingText: loadingDefaultValue && _constants.DEFAULT_UPLOADING_TEXT,
        name: name || this.getDefaultAttachment(input.value),
        previewClassname: previewClassname,
        containerClassname: containerClassname,
        preview: preview,
        onChange: this.onChange,
        onClick: this.removeValue,
        error: error,
        errorText: errorText,
        fieldTypes: fieldTypes,
        loadingTextClassname: loadingTextClassname,
        classes: classes,
        errorClassname: errorClassname,
        icon: icon,
        disabled: disabled
      });
    }
  }]);

  return AttachmentContainer;
}(_react.Component);

AttachmentContainer.propTypes = {
  onChange: _propTypes.func.isRequired,
  previewClassname: _propTypes.string,
  containerClassname: _propTypes.string,
  fieldTypes: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  loadingTextClassname: _propTypes.string,
  classes: (0, _propTypes.shape)(_propTypes.any),
  errorClassname: _propTypes.string,
  resizeConfig: (0, _propTypes.shape)({
    type: _propTypes.string,
    maxWidth: _propTypes.number,
    maxHeight: _propTypes.number
  }),
  icon: _propTypes.node,
  maxFileSize: _propTypes.number,
  input: _formTypes.inputPropTypes,
  disabled: _propTypes.bool
};
AttachmentContainer.defaultProps = {
  maxFileSize: 99999999
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)(AttachmentContainer);

exports["default"] = _default;